import React, { ReactElement } from "react";
import { ToelichtingRisicoscenariosHoofdstuk } from "../../../../../.generated/rapportage/rapportagetypes";
import { Chapter } from "../../../components/Chapter";
import { Paragraph } from "../../../components/Paragraph";
import { BarChart } from "../../../components/Chart";
import defaultTheme from "../../../../../styles/themes/default";

type ToelichtingRisicoscenariosHoofdstukProps = {
  hoofdstuk: ToelichtingRisicoscenariosHoofdstuk;
};

const ToelichtingRisicoscenariosChapter = ({
  hoofdstuk,
}: ToelichtingRisicoscenariosHoofdstukProps): ReactElement => {
  return (
    <Chapter>
      {hoofdstuk?.paragrafen &&
        Object.entries(hoofdstuk.paragrafen).map(([key, paragraaf]) => (
          <Paragraph key={key} withMarkdown>
            {paragraaf.inhoud}
          </Paragraph>
        ))}
      <BarChart
        title="Grafiek toelichting van financiële risico's"
        labels={
          hoofdstuk?.risicoscenarios?.map((scenario) => scenario.titel ?? "") ??
          []
        }
        datasets={[
          {
            label: "Bruto Inkomen",
            data:
              hoofdstuk?.risicoscenarios?.map(
                (scenario) => scenario.brutoInkomen ?? 0
              ) ?? [],
            backgroundColor: defaultTheme.colors.chartBlue,
          },
          {
            label: "Tekort",
            data:
              hoofdstuk?.risicoscenarios?.map(
                (scenario) => scenario.tekort ?? 0
              ) ?? [],
            backgroundColor: defaultTheme.colors.chartRed,
          },
          {
            label: "Inkomensverlies",
            data:
              hoofdstuk?.risicoscenarios?.map(
                (scenario) => scenario.inkomensverlies ?? 0
              ) ?? [],
            backgroundColor: defaultTheme.colors.chartRedLight,
          },
        ]}
      />
    </Chapter>
  );
};

export default ToelichtingRisicoscenariosChapter;
